

import React from 'react';
import WaitNode from './WaitNode';
// import './dnd.css'
// import ViewIcon from '@material-ui/icons/Visibility';

// import { LightTooltip } from './LightTooltip';
// import IconButton from "@material-ui/core/IconButton";

export function DesignCard  (props)  {


    const minWidth = 20; // Adjust as needed
    const paddedName = props.name.padEnd(minWidth, ' ');


    const renderAttribute = (item) =>{
      if(item.startsWith('py/object') || item.startsWith ("events") || item.startsWith('check'))
      {
        return (
        <div/>
      );
      }

      // if(item == 'taskName')
      return(
      <div class="row">
        <h5>{item.toUpperCase() + ":"}</h5>&nbsp;&nbsp; 
        <h5 className='editAttrs' >{props.attributes[item] }</h5> 
        {/* {item == 'image' ? renderImage(props.entity,item):<div/> } */}
        {/* <LightTooltip title="View Task">
              <IconButton className="toolbutton" onClick={viewTask}>
                <ViewIcon style={{color:'#feb200'}} fontSize="medium" />
              </IconButton>
            </LightTooltip> */}
      </div>
      );


    }

    // TODO: need to call this from above to get the image rendered on the design card
    const renderImage = (entity, image) => {
      if (image == undefined || image == null || image=='')
      {
        return (<div/>)
      }
      else
      {
        const url = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/image/' + entity +'/' + image
        return (
        <img className='clickimage'  src={url} ></img>
      );
      }
  
    }
  
  
    const render = () =>{
      const keys = Object.keys(props.attributes).slice(0, 4);
      return keys.map(item =>{
        return (
        <>
          {renderAttribute(item)}
        </>
        )
      });


      
    }

    if (props == null || props.attributes == null) 
    return (

      <div className="designcard">
          <h4 className="designcardtitle">{props.name}</h4>
       {/* <h4>No attributes</h4> */}
      </div> 
    );

    if (Object.keys(props.attributes).length == 0)
    return (
      <div className="designcard">
          <h4 className="designcardtitle">{props.name}</h4>
       {/* <h4>No attributes</h4> */}
      </div> 
      );

      if (Object.keys(props.attributes).length == 1)
      {
        if (props.attributes['py/object'] != null)
        return (
          <div className="designcard">
          <h4 className="designcardtitle">{props.name}</h4>

           {/* <h4>No attributes</h4> */}
         </div> 
           );
      }


   const renderTitle = ()=>{
    return (
      // <div className='row'>
      <div>
        <h4 className="designcardtitle">{paddedName}</h4>
        {/* {props.icon == undefined? <div/>: props.icon} */}
      </div>
    )
    }

   return (

      <div className="designcard">
        {renderTitle()}
        {/* <div className='horizontalline'/> */}
        {render()}

      </div>
      );



};
export default DesignCard;
  